<template>
  <div>
    <v-container class="mb-0 pb-0">
      <ProjectResponseHeader />
      <!-- <br /> -->
      <ProjectResponseMenuTab :active="0" />
      <!-- <br /> -->
      <!-- <v-layout>
        <v-flex sm12></v-flex>
      </v-layout> -->
    </v-container>
    <v-container fluid class="mb-0 pb-0">
      <!-- <v-layout>
        <v-flex sm12> -->
      <v-layout>
        <v-flex sm2 justify-end align-end>
          <ProjectStatusActions
            :status="getStatus()"
            :selected="selected"
            :downloads="downloads"
          />
        </v-flex>
        <v-flex sm9>
          <v-tabs v-model="active" slider-color="#f66">
            <v-tab>Pending ({{ getCount(2) }})</v-tab>
            <v-tab>Accepted ({{ getCount(6) }})</v-tab>
            <v-tab>Rejected ({{ getCount(4) }})</v-tab>
            <v-tab>Require Modification ({{ getCount(3) }})</v-tab>
            <v-tab-item>
              <v-card flat>
                <v-card-text class="px-0">
                  <ProjectStatusData
                    :status="2"
                    @reset="fetchStatusCount"
                    v-if="active == 0"
                    @selected="changeSelection"
                    @downloads="changeDownloads"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text class="px-0">
                  <ProjectStatusData
                    :status="6"
                    v-if="active == 1"
                    @selected="changeSelection"
                    @downloads="changeDownloads"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text class="px-0">
                  <ProjectStatusData
                    :status="4"
                    v-if="active == 2"
                    @selected="changeSelection"
                    @downloads="changeDownloads"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text class="px-0">
                  <ProjectStatusData
                    :status="3"
                    v-if="active == 3"
                    @selected="changeSelection"
                    @downloads="changeDownloads"
                  />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
      <!-- </v-flex>
      </v-layout> -->
    </v-container>
  </div>
</template>
<script>
import api from "../../api/datadash";
import { mapState } from "vuex";
import ProjectStatusData from "../../components/project/ProjectStatusData";
import ProjectStatusActions from "../../components/project/ProjectStatusActions";
import ProjectResponseHeader from "../../components/project/ProjectResponseHeader";
import ProjectResponseMenuTab from "../../components/project/ProjectResponseMenuTab";
export default {
  data() {
    return {
      active: 0,
      statusCount: null,
      selected: [],
      downloads: {
        download_project_image: null,
        download_project_audio: null,
        download_project_video: null,
        download_project_file: null,
      },
    };
  },
  components: {
    ProjectStatusData,
    ProjectStatusActions,
    ProjectResponseHeader,
    ProjectResponseMenuTab,
  },
  computed: {
    ...mapState(["auth"]),
  },
  watch: {
    active() {
      this.selected = [];
    },
  },
  created() {
    this.fetchStatusCount();
  },
  methods: {
    async fetchStatusCount() {
      const { data } = await api.fetchData(
        this.auth.token,
        `task-status-count/${this.$route.params.id}`
      );
      this.statusCount = data.data;
    },
    getCount(id) {
      let count =
        this.statusCount &&
        this.statusCount.find((status) => status.task_status_id === id);
      return count ? count.count : 0;
    },

    getStatus() {
      if (this.active == 0) return 2;
      if (this.active == 1) return 6;
      if (this.active == 2) return 4;
      if (this.active == 3) return 3;
    },

    changeSelection(data) {
      this.selected = data;
    },

    changeDownloads(data) {
      this.downloads = data;
    },
  },
};
</script>
